<template>
    <div class="class-school-item">
        <router-link :to="{ path: getPath(), query: { id: item.id, nameClass: item.name } }" target="_blank">
            <div class="class-item-header">
                {{ item.name }}
            </div>
            <div class="class-item-body">
                <div class="number-student line">
                    <strong>Sĩ số : {{ item.countMember }}</strong>
                </div>
                <br />
                <div class="excercise line">
                    <strong>{{ nameExcercise }} : {{ item.countExcerciseAssign }}</strong>
                </div>
                <div class="electronic-lectures line">
                    <strong>{{ nameElectronicLectures }} : {{ item.countElectronicLecture }}</strong>
                </div>
                <div class="lesson-planning line">
                    <strong>{{ lessonPlanning }} : {{ item.countLessonPlaning }}</strong>
                </div>
            </div>
        </router-link>
        
        <div v-if="authInfo.roleCode == roleTeacher && !isPersonalPage" class="class-item-footer display-flex justify-content-between">
            <a @click="handleDeleteClassSchool" href="javascript:;" class="item btn border-rd-20 margin-5 font-size-16 item__delete">
                Xóa
            </a>
            <div class="display-flex justity-content-end">
                <a @click="handleEditClassSchool" href="javascript:;" class="item btn btn-main border-rd-20 margin-5 font-size-16 item__add">
                    Sửa
                </a>
                <a @click="handleAddMemberClassSchool" href="javascript:;" class="item btn btn-main border-rd-20 margin-5 font-size-16 item__add">
                    Thêm học sinh
                </a>
            </div>
        </div>
        <div v-if="authInfo.roleCode == roleTeacher && isPersonalPage" @click="showModalSendDocument" class="class-item-footer display-flex justity-content-end">
            <a href="javascript:;" class="item btn btn-main border-rd-20 margin-5 font-size-16 item__add">
                <img class="icon-plus" width="20px" src="@/assets/img/plus.png" />
                <img class="icon-plus" width="20px" src="@/assets/img/plus-hover.png" />
                Gửi tài liệu
            </a>
        </div>
        <div v-if="authInfo.roleCode == roleHocSinh" class="class-item-footer display-flex justity-content-end">
            <a @click="handleLeaverClassSchool" href="javascript:;" class="item btn border-rd-20 margin-5 font-size-16 item__delete_leave">
                Rời lớp
            </a>
        </div>
    </div>
</template>
<script>
import { getAuth } from "@/utils/jwt";
import { ROLE_TEACHER,ROLE_PUPIL } from "@/store/auth/constants";
export default {
    data(){
        return{
            authInfo: getAuth(),
            roleTeacher: ROLE_TEACHER,
            roleHocSinh: ROLE_PUPIL,
        }
    },
    computed:{
        nameExcercise(){
            if(this.authInfo.roleCode == this.roleTeacher){
                return 'Số bài tập/bài kiểm tra đang giao'
            }
            return 'Số bài kiểm tra cần hoàn thành'
        },
        nameElectronicLectures(){
            if(this.authInfo.roleCode == this.roleTeacher){
                return 'Số bài giảng điện tử đang giao'
            }
            return 'Số bài giảng điện tử cần hoàn thành'
        },
        lessonPlanning(){
            if(this.authInfo.roleCode == this.roleTeacher){
                return 'Số kế hoạch bài dạy đang giao'
            }
            return 'Số kế hoạch bài dạy cần hoàn thành'
        }
    },
    props:{
        item:{
            type:Object,
            // eslint-disable-next-line vue/require-valid-default-prop
            default:{}
        },
        isPersonalPage: {
            type: Boolean,
            default: false
        },
        type:{
            type:Number,
            default:0,
        }
    },
    mounted(){
        console.log(this.type)
    },
    methods: {
        getPath(){
            if(this.type == 1 ){
                return this.authInfo.roleCode == this.roleTeacher?'/quan-ly-lop-hoc':'/lop-hoc-cua-toi'
            }
            else{
                return this.authInfo.roleCode == this.roleTeacher?'/trang-ca-nhan-giao-vien':'/trang-ca-nhan-giao-vien'
            }
            
        },
        handleLeaverClassSchool(){
            this.$emit('handleLeaverClassSchool',this.item.id)
        },
        handleAddMemberClassSchool(){
            this.$emit('handleAddMember',this.item.id)
        },
        handleEditClassSchool(){
            this.$emit('handleEdit',this.item.id)
        },
        handleDeleteClassSchool(){
            let data={
                id:this.item.id,
                name:this.item.name
            }
            this.$emit('handleDelete',data)
            
        },
        showModalSendDocument() {
            this.$emit('handleSendDocument',this.item.id)
        }
    }
}
</script>
<style lang="scss" scoped>
.margin-5 {
    margin: 5px;
}

.justity-content-end {
    justify-content: end;
}

.class-school-item {
    margin-top: 10px;
    border-radius: 20px;
    border: 1px solid #e6e6e6;

    .class-item-header {
        padding: 0.8rem 1rem;
        border-bottom: 1px solid #dfdfdf;
        background-color: #0f3dba;
        border-radius: 20px 20px 0px 0px;
        color: white;
    }

    .class-item-body {
        padding: 10px 25px 5px 25px;
        .line{
            color: black;
        }
    }

    .class-item-footer {
        padding: 0 20px 10px 20px;
        .item__delete {
            //background: #fa0602;
            color: #fa0602;
            line-height: 20px;
        }
        .item__delete_leave {
            background: #fa0602;
            color: white;
            line-height: 20px;
        }

        .item__add {
            line-height: 20px;
        }
    }
}</style>